/* eslint-disable jsx-a11y/media-has-caption */
import { Layout, Input, Select, Modal, Popover } from "antd";
import { Content } from "antd/es/layout/layout";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import styled from "styled-components";

import NO_IMAGE_AVAILABLE from "@assets/images/NO_IMAGE_AVAILABLE.jpg";
import { ReactComponent as ICON_ARROW_BACK_MENU } from "@assets/svgs/ICON_ARROW_BACK_MENU.svg";
import { ReactComponent as ICON_MEDIA_DELETE } from "@assets/svgs/ICON_MEDIA_DELETE.svg";
import { ReactComponent as ICON_MEDIA_EDIT } from "@assets/svgs/ICON_MEDIA_EDIT.svg";
import { ReactComponent as ICON_MEDIA_INFO } from "@assets/svgs/ICON_MEDIA_INFO.svg";
import { Button } from "@components/Button";
import Header from "@components/Header";
import { Icon } from "@components/Icon";
import { InnerContents } from "@components/InnerContents";
import { SideMenu } from "@components/SideMenu";
import { Text } from "@components/Text";
import {
  COLOR_BLACK,
  COLOR_DARK_GREY,
  COLOR_GREEN,
  COLOR_GREY,
  COLOR_RED,
  COLOR_WHITE,
} from "@static/COLORS";
import { CONTENT_STYLES } from "@static/CONTENT_STYLES";
import {
  KEY_FILTER_MEDIA_STATUS,
  KEY_FILTER_MEDIA_TYPE,
} from "@static/KEY_FILTER_MEDIA";
import {
  KEY_MEDIAS_ADD,
  KEY_MEDIAS_DELETE,
  KEY_MEDIAS_UPDATE,
} from "@static/PERMISSION_KEY";
import { FILTER_SIZE, MENU_SIZE, MODAL_SIZE } from "@static/SIZE";
import { getAuthUserPermissions } from "@utils/getAuthUserPermissions";
import { getAuthUserProfile } from "@utils/getAuthUserProfile";
import { getOverviewMedia } from "@utils/getOverviewMedia";
import { fetchAPI } from "@utils/https/fetchAPI";
import { useShowConfirmation } from "@utils/useShowConfirmation";

import { ContentInfo } from "./ContentInfo";
import { FormEdit } from "./FormEdit";
import { FormMultipleUpload } from "./FormMultipleUpload";
import { FormUpload } from "./FormUpload";

const { REACT_APP_API_ENDPOINT } = process.env;

const SectionGroupAction = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: ${COLOR_WHITE};
  padding: 8px;
  border-radius: 6px;
  height: 50px;
  box-sizing: border-box;
`;

const SectionMainAction = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const Line = styled.div`
  height: 20px;
  width: 1px;
  background: ${COLOR_GREY};
`;

const SectionStatusOverviewContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: space-between;
  background: ${COLOR_WHITE};
  border-radius: 6px;
  padding: 8px;
`;

const SectionStatusOverviewMedia = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  width: 100%;
  align-items: center;
  gap: 12px;
  background: ${COLOR_WHITE};
  border-radius: 6px;
  padding: 8px;
`;

const SectionStatusOverviewMediaItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;

const SectionCreate = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const SectionSelect = styled.div``;

const SectionMediaList = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  padding-bottom: 16px;
  overflow-y: scroll;
`;

const SectionMediaItem = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  flex-direction: column;
  border-radius: 6px;
  box-sizing: border-box;
  /* overflow: hidden; */
  background: rgb(245, 245, 245);
  border: 1px;
  border-style: solid;
  border-color: ${({ borderColor = COLOR_GREEN }) => borderColor};
`;

const ContainerExtension = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;
  margin-right: 5px;
  margin-top: 5px;
  padding: 2px 4px;
  border-radius: 4px;
  width: 50px;
  background: ${({ background = "red" }) => background};
  border: 1px solid ${({ borderColor = "red" }) => borderColor};
`;

const SectionGroupMedia = styled.div`
  border-radius: 6px;
  overflow: hidden;
  width: 100%;
  height: 100%;
`;

const SectionMediaContents = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 180px;
  background: ${COLOR_WHITE};
`;

const SectionMediaText = styled.div`
  padding: 8px 16px;
  width: 100%;
`;

const SectionMediaActions = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
  padding: 8px;
`;

const ContainerShare = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  margin-left: 5px;
  margin-top: 5px;
  padding: 2px 4px;
  border-radius: 4px;
  width: 50px;
  background: ${({ background = "red" }) => background};
  border: 1px solid ${({ borderColor = "red" }) => borderColor};
`;

const MAPPING_OVERVIEW_LIST = [
  { label: "Media Size", key: "mediaSize" },
  { label: "Active Media", key: "totalActiveMedia" },
  { label: "Inactive Media", key: "totalInactiveMedia" },
  { label: "Images", key: "totalImages" },
  { label: "Videos", key: "totalVideos" },
  { label: "Audio", key: "totalAudio" },
];

const MAPPING_BACKGROUND_EXTENSION = {
  audio: ["#2F54EB", "#F0F5FF"],
  image: ["#F5222D", "#FFF1F0"],
  video: ["#52C41A", "#F6FFED"],
};

export default () => {
  const showConfirmation = useShowConfirmation();

  const navigate = useNavigate();
  const location = useLocation();
  const permission = getAuthUserPermissions();
  const authUserProfile = getAuthUserProfile();
  const customerId = _.get(location, ["state", "customerId"]);
  const locationId = _.get(location, ["state", "locationId"]);
  const locationName = _.get(location, ["state", "locationName"]);

  const [dataList, setDataList] = useState([]);
  console.log("dataList :>> ", dataList);
  const [overview, setOverview] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [isCloseModal, setIsCloseModal] = useState(true);

  const [isModalVisible, setIsModalVisible] = useState({
    isOpen: false,
    modalType: null,
  });

  const initData = async () => {
    const resp = await fetchAPI({
      method: "post",
      path: "/api/v1/medias",
      isAuth: true,
      data: {
        location_id: locationId,
        customer_id: customerId,
      },
    });
    if (_.get(resp, ["status"])) {
      const medias = _.chain(resp).get(["result"]).value();
      const mediaShares = _.get(resp, ["other", "mediaShares"], []);
      const mediaList = [...medias, ...mediaShares];

      const addIsInUseInDataList = _.map(mediaList, (item) => {
        const blockMedias = _.get(item, ["blockMedias"]);
        const isInUse = _.isEmpty(blockMedias) ? false : true;
        return { ...item, isInUse };
      });
      const overviewMedia = getOverviewMedia({ medias: addIsInUseInDataList });
      setOverview(overviewMedia);
      setDataList(addIsInUseInDataList);
    }
  };

  useEffect(() => {
    initData();
  }, []);

  useEffect(() => {
    const overviewMedia = getOverviewMedia({ medias: dataList });
    setOverview(overviewMedia);
  }, [dataList]);

  const onHandleOpenModal = ({ modalType }) => {
    setIsModalVisible({ isOpen: true, modalType });
  };

  const onHandleEdit = ({ item }) => {
    setSelectedData(item);
    setIsModalVisible({ isOpen: true, modalType: "edit" });
  };

  const onHandleDelete = async ({ item }) => {
    const id = _.get(item, ["id"]);
    const path = _.get(item, ["path"]);
    const thumbnail_path = _.get(item, ["thumbnail_path"]);
    const resp = await fetchAPI({
      method: "post",
      path: `/api/v1/media-delete`,
      isAuth: true,
      data: {
        id,
        path,
        thumbnail_path,
      },
    });
    if (_.get(resp, ["status"])) {
      toast.success("Delete Media Success.");
      const updateDataList = _.chain(dataList)
        .filter((item) => {
          return _.get(item, ["id"]) !== id;
        })
        .map((item, index) => {
          return { ...item, index: index + 1 };
        })
        .value();
      setDataList(updateDataList);
    }
  };

  const [filterName, setFilterName] = useState("");
  const [filterType, setFilterType] = useState("");
  const [filterActive, setFilterActive] = useState(null);

  const onHandleFilterChange = ({ value }) => {
    setFilterName(value);
  };

  const onHandleTypeFilterChange = ({ value }) => {
    setFilterType(value || "");
  };

  const onHandleStatusFilterChange = ({ value }) => {
    setFilterActive(!_.isNil(value) ? value : null);
  };

  const filteredDataSource = _.filter(dataList, (item) => {
    const itemName = _.chain(item).get(["display_name"]).toLower().value();
    const itemType = _.chain(item).get(["extension"]).toLower().value();
    const itemStatus = _.chain(item).get(["isInUse"]).value();
    const lowerFilterName = _.toLower(filterName);
    const lowerFilterType = _.toLower(filterType);

    return (
      (_.includes(itemName, lowerFilterName) || filterName === "") &&
      (itemType === lowerFilterType ||
        filterType === "" ||
        filterType === undefined) &&
      (itemStatus === filterActive || filterActive === null)
    );
  });

  const onHandleDeleteMediaUnused = async () => {
    const unusedItems = _.chain(dataList)
      .filter((item) => {
        return !_.get(item, ["isInUse"]);
      })
      .map((item) => {
        return {
          id: _.get(item, ["id"]),
          path: _.get(item, ["path"]),
          thumbnail_path: _.get(item, ["thumbnail_path"]),
        };
      })
      .value();

    const resp = await fetchAPI({
      method: "post",
      path: `/api/v1/media-delete-unused`,
      isAuth: true,
      data: {
        unusedItems: unusedItems,
      },
    });
    if (_.get(resp, ["status"])) {
      toast.success("Delete Media Success.");
      const result = _.get(resp, ["result"]);
      const updateDataList = _.chain(dataList)
        .filter((item) => {
          const itemId = _.get(item, ["id"]);
          return !_.includes(result, itemId);
        })
        .map((item, index) => {
          return { ...item, index: index + 1 };
        })
        .value();
      setDataList(updateDataList);
    }
  };

  return (
    <Layout hasSider>
      <SideMenu />
      <Layout style={{ marginLeft: MENU_SIZE }}>
        <Header />
        <Content style={CONTENT_STYLES}>
          <InnerContents style={{ overflow: "hidden" }}>
            <SectionGroupAction>
              <SectionMainAction>
                <Button onClick={() => navigate(-1)} padding="0px">
                  <Icon
                    isCursor
                    width={14}
                    height={14}
                    style={{ marginRight: 8 }}
                  >
                    <ICON_ARROW_BACK_MENU />
                  </Icon>
                  <Text fontSize="18px" fontWeight="600">
                    Back
                  </Text>
                </Button>
                <Line />
                <Input
                  placeholder="Filter by name"
                  value={filterName}
                  onChange={(e) =>
                    onHandleFilterChange({
                      value: _.get(e, ["target", "value"]),
                    })
                  }
                  style={{ width: FILTER_SIZE + 50 }}
                />
                <Line />
                <SectionSelect>
                  <Select
                    height={32}
                    allowClear
                    placeholder="Filter by media type"
                    optionFilterProp="children"
                    style={{ width: "180px" }}
                    options={KEY_FILTER_MEDIA_TYPE}
                    onChange={(value) => onHandleTypeFilterChange({ value })}
                  />
                </SectionSelect>
                <Line />
                <SectionSelect>
                  <Select
                    style={{ width: "200px" }}
                    allowClear
                    height={32}
                    placeholder="Filter by media status"
                    optionFilterProp="children"
                    onChange={(value) => onHandleStatusFilterChange({ value })}
                    options={KEY_FILTER_MEDIA_STATUS}
                  />
                </SectionSelect>
              </SectionMainAction>
              <SectionCreate>
                {_.includes(permission, KEY_MEDIAS_ADD) && (
                  <>
                    <Button
                      // multiple upload
                      onClick={() =>
                        onHandleOpenModal({ modalType: "multiple upload" })
                      }
                      color={COLOR_GREEN}
                      fontColor={COLOR_WHITE}
                      padding="7px 15px"
                    >
                      Add Multiple Media
                    </Button>
                    <Button
                      onClick={() => onHandleOpenModal({ modalType: "upload" })}
                      color={COLOR_GREEN}
                      fontColor={COLOR_WHITE}
                      padding="7px 15px"
                    >
                      Add Media
                    </Button>
                  </>
                )}
              </SectionCreate>
            </SectionGroupAction>

            <SectionStatusOverviewContainer>
              <div style={{ display: "flex", gap: 4 }}>
                <Text fontSize="16px" fontWeight="400" color="rgb(150 150 150)">
                  Project
                </Text>
                <Text fontSize="16px" fontWeight="400" color="rgb(150 150 150)">
                  :
                </Text>
                <Text
                  style={{ maxWidth: 300 }}
                  fontSize="16px"
                  fontWeight="500"
                  isEllipsis
                  lines={1}
                  isBreak
                >
                  {locationName}
                </Text>
              </div>

              <div>
                {_.includes(permission, KEY_MEDIAS_ADD) && (
                  <>
                    <Button
                      onClick={() =>
                        showConfirmation({
                          onConfirm: () => onHandleDeleteMediaUnused(),
                        })
                      }
                      color={"red"}
                      fontColor={COLOR_WHITE}
                      padding="7px 15px"
                    >
                      Delete all media unused
                    </Button>
                  </>
                )}
              </div>
            </SectionStatusOverviewContainer>

            <SectionStatusOverviewMedia>
              {_.map(MAPPING_OVERVIEW_LIST, (item, index) => {
                const mappingKey = _.get(item, ["key"]);
                const value = _.get(overview, [mappingKey], "-");
                return (
                  <SectionStatusOverviewMediaItem key={index}>
                    <Text
                      fontSize="13px"
                      fontWeight="500"
                      color="rgb(150 150 150)"
                    >
                      {_.get(item, ["label"])}
                    </Text>
                    <Text fontSize="15px" fontWeight="600">
                      {value}
                    </Text>
                  </SectionStatusOverviewMediaItem>
                );
              })}
            </SectionStatusOverviewMedia>

            <SectionMediaList>
              {_.map(filteredDataSource, (item, index) => {
                const extension = _.get(item, ["extension"]);
                const path = `${REACT_APP_API_ENDPOINT}/${_.get(item, [
                  "path",
                ])}`;

                const thumbnail_path = _.get(item, ["thumbnail_path"]);

                const thumbnail = `${REACT_APP_API_ENDPOINT}/${_.get(item, [
                  "thumbnail_path",
                ])}`;
                const isInUse = _.get(item, ["isInUse"]);
                const mainExtensionType = _.chain(item)
                  .get(["type"])
                  .split("/")
                  .first()
                  .value();

                const isShare = _.get(item, ["is_share"]);
                return (
                  <SectionMediaItem
                    key={index}
                    borderColor={isInUse ? COLOR_GREEN : COLOR_RED}
                  >
                    {isShare && (
                      <ContainerShare>
                        <Text
                          fontWeight="500"
                          align="center"
                          color={COLOR_WHITE}
                        >
                          Share
                        </Text>
                      </ContainerShare>
                    )}
                    <ContainerExtension
                      borderColor={_.get(MAPPING_BACKGROUND_EXTENSION, [
                        mainExtensionType,
                        0,
                      ])}
                      background={_.get(MAPPING_BACKGROUND_EXTENSION, [
                        mainExtensionType,
                        1,
                      ])}
                    >
                      <Text
                        fontWeight="500"
                        align="center"
                        color={_.get(MAPPING_BACKGROUND_EXTENSION, [
                          mainExtensionType,
                          0,
                        ])}
                      >
                        {_.capitalize(extension)}
                      </Text>
                    </ContainerExtension>
                    <SectionGroupMedia>
                      <SectionMediaContents>
                        {(() => {
                          switch (mainExtensionType) {
                            case "image":
                              return (
                                <img
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "contain",
                                  }}
                                  src={path}
                                  alt={_.get(item, ["name"], "-")}
                                  onError={({ target }) => {
                                    target.onerror = null;
                                    target.src = NO_IMAGE_AVAILABLE;
                                    target.style.objectFit = "cover"; // auto cover when load image error
                                  }}
                                />
                              );
                            case "video":
                              return (
                                <ReactPlayer
                                  url={path}
                                  controls
                                  light={
                                    thumbnail_path === null ? true : thumbnail
                                  }
                                  width={"100%"}
                                  height={"100%"}
                                  style={{
                                    background: COLOR_BLACK,
                                  }}
                                />
                              );

                            case "audio":
                              return (
                                <audio
                                  controls
                                  type={_.get(item, ["type"])}
                                  src={path}
                                />
                              );

                            default:
                              return null;
                          }
                        })()}
                      </SectionMediaContents>
                      <SectionMediaText>
                        <Text isEllipsis lines={1} fontWeight="500">
                          {_.get(item, ["display_name"])}
                        </Text>
                      </SectionMediaText>
                      <SectionMediaActions>
                        <Popover
                          content={<ContentInfo mediaInfo={item} />}
                          title="Media Info"
                          trigger="click"
                        >
                          <ICON_MEDIA_INFO
                            style={{ cursor: "pointer" }}
                            fill={COLOR_DARK_GREY}
                            width={"24px"}
                            height={"24px"}
                          />
                        </Popover>

                        <Line />
                        {_.includes(permission, KEY_MEDIAS_UPDATE) && (
                          <>
                            <Icon
                              width={"24px"}
                              height={"24px"}
                              isCursor
                              onClick={() => onHandleEdit({ item })}
                            >
                              <ICON_MEDIA_EDIT fill={COLOR_DARK_GREY} />
                            </Icon>
                            <Line />
                          </>
                        )}

                        {_.includes(permission, KEY_MEDIAS_DELETE) && (
                          <Icon
                            width={"24px"}
                            height={"24px"}
                            isCursor
                            onClick={() =>
                              showConfirmation({
                                title: "Delete",
                                onConfirm: () => onHandleDelete({ item }),
                              })
                            }
                          >
                            <ICON_MEDIA_DELETE fill={COLOR_DARK_GREY} />
                          </Icon>
                        )}
                      </SectionMediaActions>
                    </SectionGroupMedia>
                  </SectionMediaItem>
                );
              })}
            </SectionMediaList>
          </InnerContents>
        </Content>
      </Layout>
      <Modal
        width={MODAL_SIZE}
        destroyOnClose={true}
        title={`${_.chain(isModalVisible)
          .get(["modalType"])
          .capitalize()
          .value()} Media`}
        open={_.get(isModalVisible, ["isOpen"])}
        footer={null}
        onCancel={() => {
          if (isCloseModal) {
            setIsModalVisible((prev) => ({ ...prev, isOpen: false }));
          }
        }}
      >
        {_.get(isModalVisible, ["modalType"]) === "upload" && (
          <FormUpload
            setIsCloseModal={setIsCloseModal}
            useInManageBlock={false}
            userProfile={authUserProfile}
            location_id={locationId}
            customer_id={customerId}
            setIsModalVisible={setIsModalVisible}
            setDataList={setDataList}
            dataList={dataList}
          />
        )}

        {_.get(isModalVisible, ["modalType"]) === "multiple upload" && (
          <FormMultipleUpload
            setIsCloseModal={setIsCloseModal}
            useInManageBlock={false}
            customer_id={customerId}
            location_id={locationId}
            setIsModalVisible={setIsModalVisible}
            setDataList={setDataList}
            dataList={dataList}
          />
        )}

        {_.get(isModalVisible, ["modalType"]) === "edit" && (
          <FormEdit
            userProfile={authUserProfile}
            location_id={locationId}
            customer_id={customerId}
            setIsModalVisible={setIsModalVisible}
            setDataList={setDataList}
            dataList={dataList}
            selectedData={selectedData}
            setSelectedData={setSelectedData}
          />
        )}
      </Modal>
    </Layout>
  );
};
